var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card"},[_c('div',[_c('span',[_vm._v("\n      "+_vm._s(_vm.$t('retailSale.cart.subtotalItems', {
          count: _vm.formattedItemCount
        }))+"\n    ")]),_c('strong',[_vm._v(_vm._s(_vm.formattedSubtotal))])]),_c('div',[_c('span',[_vm._v(_vm._s(_vm.$t('retailSale.cart.tax', { rate: _vm.formattedVatRate })))]),_c('strong',[_vm._v(_vm._s(_vm.formattedTaxTotal))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }